<template>
  <Breadcrumbs
      title="Edit Distributor Vehicle"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Distributor Vehicles', path: '/distributor-vehicles' },
      { label: 'Edit Distributor Vehicle', path: '/edit-vehicle' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <editVehicle/>
    </div>
  </div>
</template>

<script>
import editVehicle from './edit_vehicle_form.vue'
export default {
  name: 'editVehicleIndex',
  components: {
    editVehicle,
  },
}
</script>